var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-row gap-2 rounded-md",class:{
    'p-2 bg-green-200': _vm.changeType === 'add',
    'p-2 bg-red-200': _vm.changeType === 'remove',
    'p-2 bg-orange-200': _vm.changeType === 'change',
  }},[(_vm.changeType === 'add')?_c('span',{staticClass:"font-bold text-green-600"},[_vm._v("+")]):_vm._e(),(_vm.changeType === 'remove')?_c('span',{staticClass:"font-bold text-red-600"},[_vm._v("-")]):_vm._e(),(_vm.changeType === 'change')?_c('span',{staticClass:"font-bold"},[_vm._v("•")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }